<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canAddFeedback"
                            [showAdd]="true"
                            [showEdit]="canEditFeedback"
                            [showDelete]="canEditFeedback"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Safety Feedback'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [dataMap]="jobMap" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Event Date/Time'" [binding]="'eventDateTime'" [format]="'g'" [width]="170" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Employee'" [binding]="'employeeUserId'" [dataMap]="employeeMap" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Reported To'" [binding]="'reportedTo'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'JHA Status'" [binding]="'jhaStatusDisplay'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Created On'" [binding]="'createdOn'" [format]="'g'" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
